import * as common from '../common/Common';
import { appService } from '../common/AppService';

export class UserViewModel {
    public appService = appService;

    public signUp() {
        appService.navigateTo('signup');
    }

    public signIn() {
        appService.navigateTo('signin');
    }

    public signOut() {
        common.callHttp('POST', 'user/signout').then((data) => {
            common.removeCookie('authtoken');
            appService.userModel = null;
            appService.navigateTo('signin');
        });
    }

    public goToUserProfile(){
        appService.navigateTo('profile');
    }

    public goToKeyboardCode(){
        appService.navigateTo('code');
    }
}